import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  carrierId: "",
  stateId: "",
  bondTypeId: "",
};

const premiumSlice = createSlice({
  name: "premium",
  initialState,
  reducers: {
    setCarrierId(state, action) {
      state.carrierId = action.payload;
    },
    setStateId(state, action) {
      state.stateId = action.payload;
    },
    setBondTypeId(state, action) {
      state.bondTypeId = action.payload;
    },
    clearSelections(state) {
      state.carrierId = "";
      state.stateId = "";
      state.bondTypeId = "";
    },
  },
});

export const { setCarrierId, setStateId, setBondTypeId, clearSelections } = premiumSlice.actions;
export default premiumSlice.reducer;


